import Sidebar from "@/layouts/Sidebar";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

interface SideBarContextType {
  navigate: (path: string) => void;
}

const SidebarContext = React.createContext<SideBarContextType | undefined>(
  undefined
);

const SidebarProvider: React.FC<any> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <SidebarContext.Provider value={{ navigate }}>
      <div className="flex">
        <Sidebar />
        {children}
      </div>
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar deve ser usado dentro de um SidebarProvider");
  }
  return context;
};

export default SidebarProvider;
